import React from "react";
import {
  Timesheet,
  updateTimesheetApi,
  updateWeeklyTimesheetApi,
} from "../../../slices/attendanceSlice";
import moment from "moment";
import useEmployeeTimesheet from "../../../utils/custome-hooks/useEmployeeTimesheet";
import ReactQuill from "react-quill";
import { useAppDispatch } from "../../../config/hooks";

export interface AccordionProps {
  title: string;
  isOpen: boolean;
  toggleAccordion: () => void;
  data?: any;
  subtitle?: string;
  weeklyTimesheetId?: string;
}
export default function Accordion({
  title,
  isOpen,
  toggleAccordion,
  data = {},
  subtitle = "",
  weeklyTimesheetId,
}: AccordionProps) {
  console.log("@@@@@@@@@ data @@@@@@@@@@@", data);
  const { getHoliday, employeeWorking } = useEmployeeTimesheet();
  const dispatch = useAppDispatch();

  const updateTimesheet = (status: string, id: string) => {
    dispatch(
      updateTimesheetApi({
        id: id,
        weeklyApprovedStatus: status,
        weekId: weeklyTimesheetId,
      })
    );
  };

  const updateWholeTimesheet = (status: string, id: string) => {
    dispatch(
      updateWeeklyTimesheetApi({
        status: status,
        id: id,
      })
    );
  };

  return (
    <div className="border border-gray-300 rounded-md mb-2">
      <button
        className={`w-full p-3 text-left border-b border-gray-200 flex items-center justify-between
                           hover:bg-secondary-200 transition duration-300 ${
                             isOpen ? "bg-gray-200" : ""
                           }`}
        onClick={toggleAccordion}
      >
        <div className="flex items-center justify-between space-x-2">
          <h1>{title} - </h1>
          <h1 className="text-secondary-500 text-sm font-medium">
            ({subtitle})
          </h1>
          {data?.timesheet && (
            <h1
              className={`${
                data?.status == "Pending"
                  ? "text-orange-500"
                  : data.status == "Rejected"
                  ? "text-red-500"
                  : "text-green-500"
              } text-base font-bold`}
            >
              {data?.status}
            </h1>
          )}
        </div>

        <div className="flex items-center justify-between space-x-6">
          {isOpen && (
            <div className="items-center justify-end flex">
              {(data?.status == "Pending" || data?.status == "Approved") && (
                <button
                  onClick={() => updateWholeTimesheet("Rejected", data.id)}
                  className="bg-red-500 mr-5 text-exwhite-100 px-2 py-1 rounded-lg text-sm  transition duration-300"
                >
                  Reject
                </button>
              )}

              {(data?.status == "Pending" || data?.status == "Rejected") && (
                <button
                  onClick={() => updateWholeTimesheet("Approved", data.id)}
                  className="bg-secondary-500 text-exwhite-100 px-2 py-1 rounded-lg text-sm  transition duration-300"
                >
                  Approve
                </button>
              )}
            </div>
          )}
          <span
            className={`float-right transform ${
              isOpen ? "rotate-180" : "rotate-0"
            } 
                                 transition-transform duration-300`}
          >
            &#9660;
          </span>
        </div>
      </button>
      {isOpen && (
        <div>
          <table className="w-full rounded-sm border-t border-exgray-200">
            <thead className="py-1 bg-secondary-300">
              <tr className="border-b border-exgray-100">
                <th className="text-sm font-medium py-2 px-2 w-1/12 text-start">
                  Date
                </th>
                <th className="text-sm font-medium py-2 px-2 w-1/12 text-start">
                  Day
                </th>
                <th className="text-sm font-medium py-2 px-2 w-1.5/12 text-start text-nowrap">
                  Start-Time
                </th>
                <th className="text-sm font-medium py-2 px-2 w-1.5/12 text-start text-nowrap">
                  End-Time
                </th>
                <th className="text-sm font-medium py-2 px-2 w-1.5/12 text-center text-nowrap">
                  Working Hrs
                </th>
                <th className="text-sm font-medium py-2 px-2 w-6/12 text-center text-nowrap">
                  Task List
                </th>
                <th className="text-sm font-medium py-2 px-2 text-start text-nowrap">
                  Status
                </th>
              </tr>
            </thead>

            <tbody className="items-center justify-center ">
              {data?.timesheet?.map((t) => {
                var startTime = moment(t.checkIn);
                var endTime = moment(t.checkOut);
                var dif = moment.duration(endTime.diff(startTime));
                let isHalfDay =
                  dif.hours() + parseFloat(`0.${dif.minutes()}`) < 8.3;

                return (
                  <tr
                    className={`${
                      moment(t.date).format("dddd") == "Sunday" ||
                      moment(t.date).format("dddd") == "Saturday" ||
                      getHoliday(t.date)
                        ? "bg-exgray-200"
                        : isHalfDay
                        ? "bg-yellow-200"
                        : ""
                    } items-center border-b border-l border-r border-exgray-100`}
                  >
                    <td className="items-center  px-2 text-sm">
                      {moment(t.date).format("DD/MM/YYYY")}
                    </td>
                    <td className="px-2 text-sm text-start  text-secondary-500 font-medium text-nowrap">
                      {moment(t.date).format("dddd")}
                    </td>
                    <td className="px-2 text-sm text-start  text-secondary-500 font-medium text-nowrap">
                      {moment(t.checkIn).format("LT")}
                    </td>
                    <td className="px-2 text-sm text-start  text-secondary-500 font-medium text-nowrap">
                      {moment(t.checkOut).format("LT")}
                    </td>
                    <td className="px-2 text-sm text-center  text-secondary-500 font-medium">
                      {t?.status
                        ? `${dif.hours()}:${
                            dif.minutes() < 10
                              ? "0" + dif.minutes()
                              : dif.minutes()
                          }`
                        : ""}
                    </td>
                    <td className="px-2 items-center">
                      <ReactQuill
                        // style={{ paddingBottom: -15, marginBottom: -35 }}
                        value={t?.dailyReport?.dailyReport[0]}
                        readOnly={true}
                        theme={"bubble"}
                      />
                    </td>
                    <td>
                      <div className="flex items-center p-2">
                        {t.weeklyApprovedStatus == "Approved" ? (
                          <h1 className="text-sm text-green-500 font-semibold mr-5">
                            {t.weeklyApprovedStatus}
                          </h1>
                        ) : t.weeklyApprovedStatus == "Rejected" ? (
                          <h1 className="text-sm text-red-500 font-semibold mr-6">
                            {t.weeklyApprovedStatus}
                          </h1>
                        ) : null}

                        {t.weeklyApprovedStatus == "" ? (
                          <>
                            <button
                              onClick={() => updateTimesheet("Approved", t.id)}
                              className="bg-green-500 mr-2 text-exwhite-100 px-2 py-1 rounded-md text-xs  transition duration-300"
                            >
                              Approve
                            </button>
                            <button
                              onClick={() => updateTimesheet("Rejected", t.id)}
                              className="bg-red-500 text-exwhite-100 px-2 py-1 rounded-md text-xs  transition duration-300"
                            >
                              Reject
                            </button>
                          </>
                        ) : t.weeklyApprovedStatus == "Approved" ? (
                          <button
                            onClick={() => updateTimesheet("Rejected", t.id)}
                            className="bg-red-500 mr-5 text-exwhite-100 px-2 py-1 rounded-md text-xs  transition duration-300"
                          >
                            Reject
                          </button>
                        ) : (
                          <button
                            onClick={() => updateTimesheet("Approved", t.id)}
                            className="bg-green-500 text-exwhite-100 px-2 py-1 rounded-md text-xs  transition duration-300"
                          >
                            Approve
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
